import { Component, OnInit } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { Router } from '@angular/router';
import { ApiUrls } from '../../../../config/api-urls/api-urls';
import { MainService } from '../../../../provider/main.service';
declare var $: any;

@Component({
  standalone: false,
  selector: 'app-library-mgt',
  templateUrl: './library-mgt.component.html',
  styleUrls: ['./library-mgt.component.css']
})
export class LibraryMgtComponent implements OnInit {
  searchForm: FormGroup | any;
  itemPerPage = 10;
  currentPage = 1;
  total: any;
  helplineId: any
  libraryList: any = [];
  libraryId: any;
  constructor(private router: Router,
    public mainService: MainService) { }
  ngOnInit() {
    this.library_list()
  }


  pagination(event: any) {
    this.currentPage = event;
    this.library_list()
  }

  // ------- get library list -------- //

  library_list() {
    this.mainService.getApi(ApiUrls.library_list + `?pageNumber=${this.currentPage}&limit=${this.itemPerPage}`, 1).subscribe((res: any) => {
      if (res.responseCode == 200) {
        this.libraryList = res.result;
        this.total = res.paginationData.total;
      }
    })
  }

  addFaq() {
    this.router.navigate(['add-library'])
  }
  viewUser(id: any) {
    this.router.navigate(['view-library/' + id])
  }

  deleteFaqModal(id: any) {
    this.libraryId = id
    $('#delete').modal('show')
  }

  deleteLibrary() {
    const data = {
      libraryId: this.libraryId,
      status: "DELETE"
    }
    this.mainService.showSpinner();
    this.mainService.postApi(ApiUrls.actionPerform_library, data, 1).subscribe((res: any) => {
      $('#delete').modal('hide');
      this.mainService.hideSpinner();
      if (res.responseCode == 200) {
        this.libraryList = res.result;
        this.library_list()
        this.mainService.successToast(res.responseMessage);
      } else {
        this.mainService.errorToast(res.responseMessage)
      }
    })
  }
}
